import { createNamespacedHelpers } from 'vuex'
const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')

export default {
  computed: {
    ...attendanceGettersMap(['getPhaseDataByKey']),
    computedUas7() {
      const data = this.getPhaseDataByKey('atividade_doenca')?.uas7

      if (!data || !data.value) {
        return '?'
      }

      return data.value
    },
    computedUct() {
      const data = this.getPhaseDataByKey('atividade_doenca')?.uct

      if (!data || !data.value) {
        return '?'
      }

      return data.value
    },
    computedDlqi() {
      const data = this.getPhaseDataByKey('atividade_doenca')?.dlqi

      if (!data || !data.value) {
        return '?'
      }

      return data.value
    },
    computedCuq2ol() {
      const data = this.getPhaseDataByKey('atividade_doenca')?.cuq2ol

      if (!data || !Object.keys(data).length) {
        return '?'
      }

      const cuq2ol = Object.values(data).reduce((sum, value) => {
        return value ? sum + value : sum
      }, 0)

      return cuq2ol
    },
  },
}
